var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 16.1633L7.11111 20.1111C4.77841 20.0042 2.58223 18.9807 1 17.2633C1.03506 13.0629 1.79162 8.89974 3.23667 4.95556C3.29766 4.78703 3.39497 4.63398 3.5217 4.50725C3.64843 4.38052 3.80147 4.28321 3.97 4.22222C6.5758 3.4389 9.27915 3.02743 12 3C14.7209 3.02743 17.4242 3.4389 20.03 4.22222C20.1973 4.28191 20.3496 4.37735 20.4762 4.50189C20.6029 4.62642 20.7008 4.77707 20.7633 4.94333C22.2098 8.89138 22.9663 13.0588 23 17.2633C21.4178 18.9807 19.2216 20.0042 16.8889 20.1111L15.6667 16.1633",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15C7.90459 15.6508 9.94157 15.9903 12 16C14.0584 15.9903 16.0954 15.6508 18 15",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9492 10H15.0492",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04922 10H8.94922",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.25f9e4cc6b89a194224872d022a95ac2.svg";
export { ForwardRef as ReactComponent };